"use client";

import { motion } from "framer-motion";
import { Play, CircleCheckBig } from "lucide-react";
import { getViewModeChrome } from "../view-mode-chrome";

interface ExecuteAllCellsSuccessProps {
  result?: any;
  viewMode?: string;
}

export function ExecuteAllCellsSuccess({ result, viewMode}: ExecuteAllCellsSuccessProps) {
  const chrome = getViewModeChrome(viewMode);
  const successCount = result?.message?.match(/(\d+) successful/)?.[1] || "0";
  const failedCount = result?.message?.match(/(\d+) failed/)?.[1] || "0";
  
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className="w-full"
    >
      <div className={`rounded-md border ${chrome.card} overflow-hidden`}>
        <div className="px-3 py-2 flex items-center justify-between gap-3 min-w-0">
          <div className="flex items-center gap-2.5">
            <Play className={`w-3.5 h-3.5 ${chrome.iconMuted} shrink-0`} strokeWidth={2} />

            <div className="flex flex-col">
              <span className={`text-[13px] font-semibold ${chrome.text} truncate`}>
                All cells executed
              </span>
              <span className={`text-[11px] ${chrome.subtext} truncate`}>
                {successCount} successful, {failedCount} failed
              </span>
            </div>
          </div>

          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.1, type: "spring", stiffness: 300 }}
          >
            <CircleCheckBig className="h-4 w-4 text-green-500" />
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
}
